import { AccountHero as DefaultAccountHero } from 'components/src/account-page/account/AccountHero'
import {
    AccountHero as Hero,
    PersonalizedAccountHero,
} from 'components/src/AccountHero'
import {
    NEW_MY_ACCOUNT_FEATURE,
    PRIVILEGES_ENABLED,
} from 'components/src/constants'
import { Responsive } from 'components/src/core/Responsive'
import DesktopBackgroundImage from 'components/src/static/account-hero/desktop.jpg'
import MobileBackgroundImage from 'components/src/static/account-hero/mobile.jpg'
import absolutify from 'components/src/utils/url/absolutify'

const AccountHero = () =>
    NEW_MY_ACCOUNT_FEATURE ? (
        <>
            <Responsive xs>
                <DefaultAccountHero
                    imageUrl={absolutify(MobileBackgroundImage)}
                    headingColor="light"
                    withOverlay={false}
                />
            </Responsive>
            <Responsive md up>
                <DefaultAccountHero
                    imageUrl={absolutify(DesktopBackgroundImage)}
                    headingColor="light"
                    withOverlay={false}
                />
            </Responsive>
        </>
    ) : PRIVILEGES_ENABLED ? (
        <PersonalizedAccountHero />
    ) : (
        <Hero asImgElement />
    )

export default AccountHero
